import React from 'react';
import { Link } from 'react-router-dom';
import './Style.css'; // 👈 CSS import করা হলো



const NavBar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark" style={{position:'relative', zIndex:1000}}>
      <div className="container-fluid">
        {/* Logo */}
        <div className="d-flex align-items-center">
          <img
            src="/image/logo.png"
            alt="logo"
            style={{ width: '30px', height: '30px', objectFit: 'contain' }}
          />
        </div>

        {/* Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
          <ul className="navbar-nav text-center gap-3">
            <li className="nav-item">
              <Link to="/home" className="nav-link text-white fs-5">HOME</Link>
            </li>

            {/* Hover Dropdown */}
            <li className="nav-item dropdown hover-dropdown">
              <Link  to ="/page" className="nav-link dropdown-toggle text-white fs-5"
             >PAGES</Link>

              <ul className="dropdown-menu" >
                <li><Link className="dropdown-item" to="/page/about">About</Link></li>
                <li><Link className="dropdown-item" to="/page/contact">Contact</Link></li>
                <li><Link className="dropdown-item" to="/page/faq">FAQ</Link></li>
                <li><Link className="dropdown-item" to="/page/gallery">Gallery</Link></li>
                <li><Link className="dropdown-item" to="/page/price">Price</Link></li>
                <li><Link className="dropdown-item" to="/page/teams">Teams</Link></li>
              
              </ul>-
            </li>

            <li className="nav-item">
              <Link to="/service" className="nav-link text-white fs-5">SERVICES</Link>
            </li>
            <li className="nav-item">
              <Link to="/rooms" className="nav-link text-white fs-5">ROOM & SUITES</Link>
            </li>
            <li className="nav-item">
              <Link to="/news" className="nav-link text-white fs-5">NEWS</Link>
            </li>
          </ul>
        </div>

        {/* Right Button */}
        <div className="d-none d-lg-block">
          <button className="btn btn-secondary p-3">Right Button</button>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
